import { useState } from "react";

const TestComponent = () => {
  const [student, setStudent] = useState({ admNo: "", names: "", course: "" });
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "300px",
          height: "500px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "100%",
          }}
        >
          <label>Admission Number</label>
          <input
            type="text"
            value={student.admNo}
            onChange={(e) => {
              return setStudent({ ...student, admNo: e.target.value });
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "100%",
          }}
        >
          <label>Names</label>
          <input
            type="text"
            value={student.names}
            onChange={(e) => {
              return setStudent({ ...student, names: e.target.value });
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "100%",
          }}
        >
          <label>Course</label>
          <input
            type="text"
            value={student.course}
            onChange={(e) => {
              return setStudent({ ...student, course: e.target.value });
            }}
          />
        </div>
      </div>
      <div>
        {student.admNo} &nbsp; {student.names} &nbsp; {student.course}
      </div>
    </>
  );
};

export default TestComponent;
